const quantitySelectors = document.querySelectorAll('.quantity-selector');

quantitySelectors.forEach((selector) => {
  selector.addEventListener('input', function (e) {
    const quantity = parseInt(this.value);
    const itemPrice = parseFloat(parseFloat(this.dataset.itemPrice.replace(/,/g, '')));
    const itemKey = this.dataset.lineItemKey;
    const currency = this.dataset.currencySymbol;
    const totalPrice = parseFloat((quantity * itemPrice).toFixed(2)).toLocaleString();

    // Update displayed price
    const priceElement = document.getElementById(`price_${itemKey}`);
    priceElement.innerText = currency + totalPrice;

    // Update cart using Shopify's AJAX API
    const data = {
      updates: {
        [itemKey]: quantity,
      },
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Update cart total if needed
        if (document.getElementById('cart-total')) {
          document.getElementById('cart-total').innerText =
            currency + parseFloat((cart.total_price / 100).toFixed(2)).toLocaleString();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });
});
